import { render, staticRenderFns } from "./SummaryMainText.vue?vue&type=template&id=03f323f2&scoped=true&"
import script from "./SummaryMainText.vue?vue&type=script&lang=js&"
export * from "./SummaryMainText.vue?vue&type=script&lang=js&"
import style0 from "./SummaryMainText.vue?vue&type=style&index=0&id=03f323f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f323f2",
  null
  
)

export default component.exports